import { useState } from 'react'
import CollectionsTab from '../collaborator/finance/CollectionsTab'
import ExpensesTab from '../collaborator/finance/ExpensesTab'
import CashPositionTab from '../collaborator/finance/CashPositionTab'

type TabKey = 'collections' | 'expenses' | 'cash_position'

interface Tab {
  key: TabKey
  label: string
}

const tabs: Tab[] = [
  { key: 'collections', label: 'Cobranza' },
  { key: 'expenses', label: 'Gastos' },
  { key: 'cash_position', label: 'Posición de Caja' },
]

/**
 * Shared Finanzas page: renders the same 3-tab structure (Cobranza, Gastos,
 * Posición de Caja) for both the admin route (`/admin/finanzas`) and the
 * `finanzas` collaborator panel route (`/finanzas`). The backend grants both
 * roles the same company-wide aggregate via `@require_panel("finanzas")`, so
 * there is intentionally only one implementation of this page -- same
 * pattern as `LogisticaPage.tsx`.
 */
export default function FinanzasPage() {
  const [activeTab, setActiveTab] = useState<TabKey>('collections')

  return (
    <div>
      <h1 className="text-2xl font-bold text-espresso-800 mb-2">Finanzas</h1>
      <p className="text-sm text-espresso-500 mb-6">
        Visibilidad direccional de caja: cobranza pendiente, gastos operativos y la posición neta
        entre ambos. No reemplaza una conciliación bancaria ni contabilidad de partida doble.
      </p>

      <div role="tablist" aria-label="Secciones de finanzas" className="flex flex-wrap gap-1 border-b border-espresso-200 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            role="tab"
            aria-selected={activeTab === tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-2 text-sm font-medium rounded-t-md border-b-2 -mb-px focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta-500 ${
              activeTab === tab.key
                ? 'border-terracotta-600 text-terracotta-700 bg-terracotta-50'
                : 'border-transparent text-espresso-500 hover:text-espresso-800 hover:bg-cream-100'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div role="tabpanel">
        {activeTab === 'collections' && <CollectionsTab />}
        {activeTab === 'expenses' && <ExpensesTab />}
        {activeTab === 'cash_position' && <CashPositionTab />}
      </div>
    </div>
  )
}
